'use client';

import { useRouter } from 'next/navigation';

import { useSecureMutation } from '@/shared/hooks/apis/useApiHooks';
import { useClearQueryCache } from '@/shared/hooks/useClearQueryCache';
import { useAuthStore } from '@/shared/store/authStore';

const LOGOUT_MUTATION_KEY = ['auth', 'logout'] as const;

export function useLogout(redirectTo: string = '/login') {
  const router = useRouter();
  const { clearSession } = useAuthStore();
  const clearCache = useClearQueryCache();

  return useSecureMutation<null, void>(
    [...LOGOUT_MUTATION_KEY],
    'post',
    () => ({
      url: '/api/auth/logout',
      body: undefined,
      init: {
        credentials: 'include', // important to send the httpOnly cookie
      },
    }),
    {
      onSettled: async () => {
        // Step 1: clear session from the auth store
        clearSession();
        // Step 2: clear all React Query caches
        await clearCache();
        // Step 3: redirect the user to the login page (or another route)
        router.replace(redirectTo);
      },
    },
  );
}
